import React, { useContext } from "react";
import { FaCheckDouble, FaLeaf, FaFileContract, FaIndustry } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/mpcb_consent_hero_1776820121393.png';

function MPCBConsent() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/mpcb-consent');
    } else {
      navigate('/login', { state: { from: '/booking/mpcb-consent' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">MPCB Consent & License</h1>
          <p className="hero-subtitle">
            Navigate the complexities of environmental regulations. Expert assistance in securing MPCB Consent to Establish and Operate.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Environmental Compliance Made Easy</h2>
              <p className="article-text">
                Obtaining consent from the Maharashtra Pollution Control Board (MPCB) is mandatory for industries generating pollution or operating in restricted zones. We simplify the regulatory landscape, guiding you through the application process for Consent to Establish (CTE) and Consent to Operate (CTO).
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Our Services Include</h2>
              <p className="article-text">
                <br />- <strong>Application Preparation:</strong> Comprehensive compilation of all required documents and environmental plans.
                <br />- <strong>Liaison & Follow-up:</strong> Engaging with MPCB officials to streamline the approval process.
                <br />- <strong>Renewal Services:</strong> Timely renewal of CTO to prevent operational disruptions.
                <br />- <strong>Compliance Audits:</strong> Pre-assessment to ensure your operations meet MPCB standards.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The Importance of Compliance</h2>
              <p className="article-text">
                Staying compliant not only avoids hefty legal penalties and closures but also demonstrates a corporate commitment to sustainable and environmentally responsible operations.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Advantages</h4>
              <ul className="key-list">
                <li><FaLeaf className="check-icon" /> Eco-Compliance</li>
                <li><FaFileContract className="check-icon" /> License Security</li>
                <li><FaIndustry className="check-icon" /> Uninterrupted Ops</li>
                <li><FaCheckDouble className="check-icon" /> Expert Liaison</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Need Consent?</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Let our experts handle your environmental licensing.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Get Started
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default MPCBConsent;
